import { render, staticRenderFns } from "./TerritorialCard.vue?vue&type=template&id=9621684e"
import script from "./TerritorialCard.vue?vue&type=script&lang=js"
export * from "./TerritorialCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports